module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-03-m-jp.d62c973da1daf15e9e2903407a5044d2.png";